"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTrackRecordsProperty = exports.trackRecordsPropertyDefinition = void 0;
exports.trackRecordsPropertyDefinition = {
    view: { label: 'Track records' },
    constraints: [
        {
            name: 'properties',
            argument: ['track-record'],
        },
    ],
    type: 'container',
    multiple: true,
    name: 'track-records',
};
const isTrackRecordsProperty = (prop) => {
    return prop.name === exports.trackRecordsPropertyDefinition.name;
};
exports.isTrackRecordsProperty = isTrackRecordsProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJhY2stcmVjb3Jkcy5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3RyYWNrLXJlY29yZHMucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSw4QkFBOEIsR0FBRztJQUM1QyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsZUFBZSxFQUFFO0lBQ2hDLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFlBQVk7WUFDbEIsUUFBUSxFQUFFLENBQUMsY0FBYyxDQUFDO1NBQzNCO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsV0FBVztJQUNqQixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxlQUFlO0NBQ1UsQ0FBQTtBQUkxQixNQUFNLHNCQUFzQixHQUFHLENBQUMsSUFBa0IsRUFBZ0MsRUFBRTtJQUN6RixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssc0NBQThCLENBQUMsSUFBSSxDQUFBO0FBQzFELENBQUMsQ0FBQTtBQUZZLFFBQUEsc0JBQXNCLDBCQUVsQyJ9